import React from 'react'

import { useNewFeature } from '../contexts/NewFeature'
import { useNavigation } from '../contexts/NavigationContext'

const ProcessesRedirectWrapper = ({ Default, ...props }) => {
  const { isActive } = useNewFeature('PROCESSES')
  const navigate = useNavigation()

  if (!isActive) navigate('/')

  return <Default {...props} />
}

export default ProcessesRedirectWrapper
